const ContatoFixoSchema = (props) => ({
  title: 'AgSUS Contato fixo',
  fieldsets: [
    {
      id: 'default',
      title: 'Conteúdo',
      fields: ['rotuloPequeno', 'rotulo', 'link', 'tipo'],
    },
  ],
  properties: {
    rotuloPequeno: {
      title: 'Texto pequeno',
      description: 'Linha de cima, em letra menor. Ex.: Fale agora com a',
    },
    rotulo: {
      title: 'Texto principal',
      description: 'Linha de baixo, em destaque. Ex.: Saúde Digital AgSUS',
    },
    link: {
      title: 'Link',
      description:
        'Endereço completo. Sem link, o botão não aparece na página. Ex.: https://wa.me/5561998109919',
    },
    tipo: {
      title: 'Tipo',
      description:
        'WhatsApp põe o ícone do aplicativo e a cor verde; Link usa o azul da AgSUS.',
      choices: [
        ['link', 'Link'],
        ['whatsapp', 'WhatsApp'],
      ],
      default: 'link',
    },
  },
  required: [],
});

export default ContatoFixoSchema;
